export default __webpack_public_path__ + "10dec88efb92ceab99a732b65173935c.png";